module.exports = __webpack_public_path__ + "static/media/left_top_bg.78751cce.png";